
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Sabitle',
	'find_label': 'Bul',
	'findCancelLabel': 'İptal',
	'dataPaneLabel': 'Veri',
	'sourcePaneLabel': 'Seçilen kaynaklar',
	'sourcePaneContentLabel': 'Bir kaynak seç',
	'emptySourcePaneTitle': 'Bir kaynak seç',
	'emptySourcePaneCaption': 'Bir gösterge panosu oluşturmak için kullanmak üzere veri eklemek için tıklatarak bir kaynak seçin.',
	'addDataSource': 'Bir kaynak seç',
	'addDataDashboardCoachMarkContents': 'Veri panosundan gösterge panonuza verileri sürükleyip bırakın.',
	'addDataStoryCoachMarkContents': 'Veri panosundan hikayenize verileri sürükleyip bırakın.',
	'addDataCoachMarkTitle': 'Veri ekle',
	'selectSourcesText': '%{app} oluşturmak için bir veri kaynağı seçin ve ekleyin.',
	'selectSourcesLabel': 'Bir kaynak seç',
	'errorSourcesTitle': 'Veri ağacı yüklenemedi',
	'errorLoadingDataSources': 'Veri kümeleri listesi yüklenirken hata oluştu',
	'errorLoadingDataTree': 'Ağaç yüklenirken bir hata oluştu',
	'dataSetPaneLastUpdated': 'Son güncellenme zamanı: %{date}',
	'dataSourcePaneDateUnknown': 'Bilinmiyor',
	'moreTitle': 'Daha fazla',
	'backLabel': 'Geri git',
	'addDataSourceDialogTitle': 'Bir kaynak seç',
	'addDataSourceDialogButtonLabel': 'Ekle',
	'dlg_use': 'Kullan',
	'dlg_RelinkDataSourceTitle': '"%{dataSourceName}" veri kümesini şununla değiştir ...',
	'propertiesDialogTitle': 'Özellikler',
	'loadingMetadata': 'Meta veriler yükleniyor',
	'missingDataSetData': 'Bu veri kümesi için veriler kullanılamıyor. Kaynağa erişim için veri kümesini yenileyin veya sistem yöneticinizle görüşün.',
	'errorLoadingSource': '"%{sourceName}" ile ilgili meta veri yüklenmedi. Lütfen ayrıntılar için sistem yöneticinizle görüşün.',
	'errorMessageTitle': 'Hata',
	'calculation_navigation_in_use': 'Hesaplamaları, süzgeçleri ya da dolaşma yollarını silmek, silinmiş öğeye gönderme yapan tüm görselleştirmeleri geçersiz kılar. Silmek istediğinizden emin misiniz?',
	'delete_confirm': 'Silmeyi onayla',
	'previewUnavailable': 'Veri tepsisi ve genel süzgeçler bu paket tipi için kullanılamıyor.',
	'contextualGridTabName': 'Görselleştirme verileri',
	'DATA_TRAY_no_data_text': 'Şu anda herhangi bir veri yok',
	'contextualGridMenuLabel': 'Görselleştirme verileri menüsü',
	'contextualGridExport': 'Dışa aktar',
	'nullValueText': 'Boş değerli',
	'forecastDetailsTabName': 'İstatistik ayrıntılarını tahmin etme',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Doğruluk Ölçümleri',
	'forecastDetailsSmoothingCoefLabel': 'Parametreler',
	'forecastDetailsDiagnostics': 'Tanılamalar',
	'forecastDetailsForecastLabel': 'Tahmin',
	'forecastDetailsStatusLabel': 'Durum',
	'forecastDetailsAccuracyPercentLabel': 'Doğruluk Yüzdesi',
	'forecastDetailsTrendLabel': 'Eğilim',
	'forecastDetailsSeasonLabel': 'Mevsimsellik',
	'forecastDetailsSeasonalPeriodLabel': 'Mevsimsel dönem',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Eksik sayı',
	'forecastDetailsSeriesLengthLabel': 'Seri uzunluğu',
	'forecastDetailsIgnoredPeriods': 'Yoksayılan dönemler',
	'forecastDetailsTrendStrength': 'Eğilim gücü',
	'forecastDetailsSeasonalityStrength': 'Mevsimsellik gücü',
	'forecastDetailsTimeDeltaUnit': 'Tarih / saat aralığı',
	'forecastDetailsNotes': 'Notlar'
});
